import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import Head from "@/components/Head/index.vue";
import { defineComponent, reactive } from "vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { useRouter } from "vue-router";
export default defineComponent({
  //name: "Information",
  components: {
    Head: Head
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var router = useRouter(); // 获取个人资料

    var Data = reactive({
      expandList: [],
      dataExpand: [],
      detail: {}
    });

    function getDetail() {
      return _getDetail.apply(this, arguments);
    }

    function _getDetail() {
      _getDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$globalProperti, data, ExpandList, DataExpand;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getInformation"]();

              case 2:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                Object.assign(Data.detail, data);
                _context.next = 7;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getExpand"]();

              case 7:
                ExpandList = _context.sent;
                _context.next = 10;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getExpandContent"](Data.detail.userId);

              case 10:
                DataExpand = _context.sent;
                Object.assign(Data.expandList, ExpandList.data.list);
                Object.assign(Data.dataExpand, DataExpand.data);
                Data.expandList.forEach(function (val) {
                  val.arr = [];
                });
                Data.expandList.forEach(function (item) {
                  Data.dataExpand.forEach(function (item1) {
                    if (item1.expandValue) {
                      item1.expandValue.split(",").forEach(function (item2) {
                        if (item.expandId == item1.expandId) {
                          item.arr.push({
                            expandValue: item2,
                            expandId: item.expandId
                          });
                        }
                      });
                    }
                  });
                });

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getDetail.apply(this, arguments);
    }

    getDetail(); // 页面激活钩子函数
    // onActivated(() => {
    //   // 重新加载
    //   getDetail();
    // });
    // 编辑

    var edit = function edit() {
      router.push({
        name: "informationEdit",
        query: {
          userId: Data.detail.userId
        }
      });
    };

    return {
      edit: edit,
      Data: Data
    };
  }
});